import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    passwordLabel: 'Password',
    requiredFieldValidation: 'This field is required',
    submitButtonLabel: 'Submit',
    title: 'Create New Password',
  },
})
